<template>
  <!-- 维修站验证 -->
  <div class="register-page ">
    <!-- <div class="content">
      <van-form @submit="onSubmit" :show-error="false">
        <van-field v-model="clientInfo.clientName" name="维修站名称" label="维修站名称" placeholder="点击填写维修站名称"
          :rules="[{ required: true, message: '请输入维修站名称' }]" disabled />
        <van-field v-model="clientInfo.detailAddress" name="维修站地址" label="维修站地址" placeholder="点击填写维修站地址"
         disabled />
        <van-field :value="clientInfo.contactMobile + '(' + clientInfo.contactPerson + ')'" name="维修站老板手机号"
          label="维修站老板手机号" :rules="[{ required: true, message: '维修站老板手机号' }]" disabled></van-field>
        <van-field v-model="kongzTokenDTO.name" name="name" label="姓名" placeholder="点击填写姓名"
          :rules="[{ required: true, message: '请输入姓名' }]" />
        <van-field v-model="password" name="password" label="密码" placeholder="点击设置密码" type="password" v-if="clientUser"
          :rules="[{ required: true, message: '请输入密码' }]" />
        <van-field v-model="confirmPassword" name="confirmPassword" label="确认密码" placeholder="点击确认密码" v-if="clientUser"
         :rules="[{ required: true, message: '请输入确认密码' },{ validator: validatorPassword, message: '密码不一致' }]" type="password" />
        <van-field v-model="kongzTokenDTO.phone" name="phone" label="手机号" placeholder="点击填写手机号" disabled
          :rules="[{ required: true, message: '请输入手机号' }]">
          <template #button>
            <div @click="getCode(kongzTokenDTO.phone)">
              <countdownButton ref="countDown"></countdownButton>
            </div>
          </template>
        </van-field>
        <van-field v-model="verifyCode" name="verifyCode" label="验证码" placeholder="点击填写验证码"
          :rules="[{ required: true, message: '请输入验证码' }]" />
        <div class="confirmButton">
          <van-button block type="primary" native-type="submit">确认{{ fixedButtonText }}
          </van-button>
        </div>
      </van-form>
    </div> -->
  </div>
</template>

<script>
// import countdownButton from './countdown-button.vue'
// import { cryptoUtils } from '@/utils/common'
import validators from '@/utils/validators'
import { kangzhongApi } from '@/api/bind'
export default {
  components: {
    // countdownButton
  },
  props: {
    clientInfo: {
      type: Object,
      default: () => { }
    },
    kongzTokenDTO: {
      type: Object,
      default: () => { }
    },
    fixedButtonText: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      verifyCode: '', // 验证码
      password: '',
      confirmPassword: '',
      clientUser: ''
    }
  },
  mounted () {
    this.onSubmit()
  },
  computed: {},
  methods: {
    // queryUser () {
    //   this.$toast.loading({
    //     duration: 0,
    //     message: '加载中...',
    //     forbidClick: true
    //   })
    //   kangzhongApi.queryUser({ userMobile: this.kongzTokenDTO.phone }).then(res => {
    //     if (res.data.resultCode === '0') {
    //       this.$toast.clear()
    //       const { clientUser } = res.data.resultData
    //       this.clientUser = clientUser || ''
    //       this.onSubmit()
    //     }
    //   }).catch(() => { this.$toast.clear() })
    // },
    // 验证确认密码
    validatorPassword (val) {
      return this.password === val
    },
    validatorPhone (val) {
      return validators.checkMobile(val)
    },
    getCode (phone) {
      if (!this.$refs.countDown.isGeting && phone.trim()) {
        kangzhongApi.getVerifyCode({ phone: phone.trim() }).then(res => {
          if (res.data.resultCode === '0') {
            this.$toast('已发送验证码')
            this.$refs.countDown.startDown()
          }
        })
      }
    },
    onSubmit () {
      let data = {
        uuid: this.kongzTokenDTO.uuid,
        phone: this.kongzTokenDTO.phone,
        name: this.kongzTokenDTO.name,
        // verifyCode: this.verifyCode.trim(),
        clientName: this.clientInfo.clientName,
        detailAddress: this.clientInfo.detailAddress,
        provinceName: this.clientInfo.provinceName,
        cityName: this.clientInfo.cityName,
        countyName: this.clientInfo.countyName,
        userRole: this.kongzTokenDTO.userRole,
        clientCode: this.clientInfo.clientCode,
        // password: cryptoUtils.AESEncrypt(this.password),
        isUserCreate: '01'
      }
      this.$emit('submit', data)
    }
  }
}
</script>
<style  scoped lang="less">
.register-page {
  .content {
    background-color: #fff;
  }

  .van-cell {
    background-color: #fff;

    /deep/ .van-field__label {
      width: 100%;
    }
  }
}

.confirmButton {
  padding: 0.5rem;
}
</style>
